import SEO from '../components/SEO';
import ProgressiveBackground from '../components/ProgressiveBackground';

const About: React.FC = () => {
    const text = `✔ Медицинский психолог с опытом работы в больнице
Я работаю в онкологическом и иммунологическом отделениях одной из ведущих больниц Израиля, поэтому хорошо понимаю, с какими переживаниями сталкиваются люди, столкнувшиеся с болезнью, их близкие и все, кто испытывает стресс, тревогу или эмоциональное истощение.

✔ Интегративный подход
Я использую сочетание методик (КПТ, гештальт, кризисное вмешательство, психоонкология), подбирая их индивидуально под запрос и потребности каждого человека.

✔ Личный опыт преодоления онкологического диагноза
Я не только работаю с темой психоонкологии, но и сама прошла этот путь. Это позволяет мне глубже понимать клиентов и работать не только с теоретическими знаниями, но и с личным пониманием сложности этого опыта.

✔ Высокий уровень профессиональной поддержки
Чтобы обеспечивать качественную психологическую помощь, я еженедельно посещаю супервизию и личную терапию. Это помогает мне развиваться как специалисту, отслеживать свою работу и поддерживать высокий профессиональный стандарт.

✔ Онлайн-формат
Я провожу консультации онлайн, что делает их доступными независимо от вашего местоположения. Это удобно, безопасно и позволяет получить поддержку в комфортной для вас обстановке.

Если вам нужна помощь, я буду рада поддержать вас. Вы не одни!`

    return (
        <>
            <SEO
                title="Обо мне | Медицинский психолог Ольга Гальперина"
                description="Медицинский психолог с опытом работы в больнице. Специализация: КПТ, гештальт, кризисное вмешательство, психоонкология. Онлайн консультации."
                keywords="онлайн психолог, кпт психолог, психоонкология, медицинский психолог, психологическая помощь онлайн"
                canonical="/about"
                jsonLd={{
                    "@context": "https://schema.org",
                    "@type": "ProfilePage",
                    "mainEntity": {
                        "@type": "Person",
                        "name": "Ольга Гальперина",
                        "jobTitle": "Медицинский психолог",
                        "description": "Медицинский психолог с опытом работы в больнице. Специализация: КПТ, гештальт, кризисное вмешательство, психоонкология.",
                        "url": "https://olgagalperina.com",
                        "knowsAbout": ["Когнитивно-поведенческая терапия", "Гештальт-терапия", "Психоонкология", "Кризисное вмешательство"],
                        "hasOccupation": {
                            "@type": "Occupation",
                            "name": "Онлайн психолог",
                            "description": "Проведение онлайн консультаций по психологической поддержке",
                            "occupationLocation": {
                                "@type": "Place",
                                "name": "Онлайн"
                            },
                            "skills": "КПТ терапия, психоонкология, кризисное вмешательство"
                        }
                    }
                }}
            />
            <div className="main-content-container">
                <div className="page-header">Обо мне</div>
                <div className="main-content main-content-reverse">
                    <div className="image-wrapper image-wrapper-right">
                        <ProgressiveBackground
                            imageName="about-page"
                            className="main-image-right"
                            ariaLabel="Медицинский психолог, специалист по КПТ терапии"
                        />
                    </div>
                    <div className="divider-container ">
                        <div className="divider"></div>
                    </div>
                    <div className="main-content-area main-content-area-left">
                        <div className="main-content-text">{text}</div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default About;
